import React from "react";
import GOINestedTitles from "../GOIHeaderSection/GOINestedTitles";
import useWidth from "../../../hooks/useWidth";

const NestedParentHeader = ({ parents }) => {
  const ref = React.useRef(null);
  const outerWidth = useWidth(ref);

  return (
    <div className="mb-10 nested-header-outer" ref={ref}>
      <div
        id="nested-header-wrapper"
        className="goi-header-section-name-wrapper"
      >
        <GOINestedTitles
          outerWidth={outerWidth}
          items={parents}
          mainHeaders={true}
        />
      </div>
    </div>
  );
};

export default NestedParentHeader;
